// Import here Polyfills if needed. Recommended core-js (npm i -D core-js)
// import "core-js/fn/array.find"
// ...
import {
  ready,
  openPage,
  setTitle,
  call,
  readSystemParameter,
  getUserUKeysByChannelId,
  getUkeyByChannelId,
  getLoginStatus,
  userLogin,
  closePage,
  login
} from '@sinolink/jssdk'
import { OpenAppParam, OpenAppUrlParam } from './types/EvolutionTypes'
import { isIframeClient, iframePostMessage, getShortLink } from '../tools/utils'

import MobileDetect from 'mobile-detect'
import Clipboard from 'clipboard'
import URI from 'urijs'
// import { async } from 'q';

// 微信授权， H5支付相关代码
import wechatAccount from './wechatAccount'
import webPay from './webPay'

declare const window: any

//特殊环境情况可通过全局变量修改
const EVOLUTION_UNIVERSAL_URL =
  (<any>window).EVOLUTION_UNIVERSAL_URL ||
  window.location.toString().indexOf('https://devwebapps.yjbtest.com') > -1
    ? `https://linkm.yjbtest.com/download/app-download.html`
    : `https://linkm.yongjinbao.com.cn/download/app-download.html`
const EVOLUTION_TXAPP_URL =
  (<any>window).EVOLUTION_TXAPP_URL || `https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.gjzq.yjb2`
const EVOLUTION_ANDOWNLOAD_URL =
  (<any>window).EVOLUTION_ANDOWNLOAD_URL ||
  `https://appdl.yongjinbao.com.cn/yjb/android/yongjinbao.apk`
const EVOLUTION_MINIAPP_URL = (<any>window).EVOLUTION_MINIAPP_URL || EVOLUTION_UNIVERSAL_URL

export class Evolution {
  /**
   * 获取AppId
   * @function getAppId
   * @returns {Promise<string>}
   */
  getAppId = (): Promise<string> => {
    return new Promise((resolve: (value: string | undefined) => void) => {
        let appId: string = 'yjbweb'
        //判断微信环境
        const browserMesg: string = navigator.userAgent.toLocaleLowerCase();

        if(browserMesg.indexOf('micromessenger') >= 0) {
          appId = 'yjbwx'
          resolve(appId);
          return;
        }

        //判断非佣金宝客户端hybrid环境
        let md: MobileDetect = new MobileDetect((<any>window).navigator.userAgent)
        const os: string = md.os();

        //移动端
        if('iOS' === os || 'AndroidOS' === os) {
          appId = 'yjbweb';
        } 

        //判断佣金宝客户端环境
        ;(<any>window).setTimeout(() => {
          resolve(appId);
        }, 100);

        ready().then(_ => {
          appId = 'yjb3.0';
          
          resolve(appId);
        })
      }
    )
  }

  /**
   * 获取页面路径
   * @function getPagePath
   * @returns {string}
   */
  getPagePath = (): string => {
    let page_url = ''
    let curWwwPath = window.document.location.href
    curWwwPath = curWwwPath.split('?')[0]
    page_url = curWwwPath.substring(0, curWwwPath.lastIndexOf('/') + 1)
    return page_url
  }

  /**
   * 打开新页面
   * @function pageInit
   * @param {string} URL 页面URL
   * @param {boolean} needCloseCurrentView 是否需要关闭当前页面 缺省false
   * @param {object} config 打开页面参数
   * @returns {Promise<void>}
   */
  pageInit = async (
    URL: string,
    needCloseCurrentView?: boolean,
    config?: object
  ): Promise<void> => {
    let oConfig: any = config || {}
    if (URL.indexOf('://') === -1 && URL.indexOf('/') !== 0) {
      //非全路径 且 非hybrid路径
      URL = this.getPagePath() + URL
    }
    if ((await this.getAppId()) === 'yjb3.0') {
      if (window.document.title) {
        oConfig.title = window.document.title
      }
      openPage(
        {
          leftType: oConfig.leftType || 1,
          url: URL,
          rightType: oConfig.rightType || 99,
          rightText: oConfig.rightText || '',
          rightJS: oConfig.rightJS || ''
        },
        needCloseCurrentView
      )
    } else {
      if (needCloseCurrentView) {
        window.location.replace(URL)
      } else {
        window.location.href = URL
      }
    }
  }

  /**
   * 页面返回
   * @function goBackPage
   * @param {any} config 设置参数
   * @returns {Promise<void>}
   */
  goBackPage = async (config?: any): Promise<void> => {
    const appId = await this.getAppId()
    if (appId === 'yjb3.0') {
      closePage(config)
    } else {
      if (appId === 'yjbwx' && config.type == 2) {
        //返回至首页,微信需要单独适配
        try {
          //适配微信
          setTimeout(function() {
            ;(<any>window).WeixinJSBridge.call('closeWindow')
          }, 500)
        } catch (e) {}
        window.close()
      } else {
        window.history.go(-1)
      }
    }
  }

  /**
   * 设置标题栏
   * @function setTitle
   * @param {any} config 设置参数(类open参数)
   * @returns {Promise<any>}
   */
  setTitles = async (config?: any): Promise<void> => {
    const appId = await this.getAppId()
    if (appId === 'yjb3.0') {
      setTitle(config)
    } else {
      window.document.title = config.title
    }
  }

  // /**
  //  *客户端页面跳转
  //  */
  // clientJumps = async (config: any, channelId: string): Promise<void> => {
  // 	const type = config.type;
  // 	let loginType:string = '0';
  // 	if (type) {
  // 		//需要普通交易登录
  // 		loginType = '1';
  // 	} else if (type) {
  // 		//需要信用交易登录
  // 		loginType = '2';
  // 	}
  // 	const beginLoginResult = await beginLogin(loginType,channelId);
  // 	if(beginLoginResult.code === 0){
  // 		clientJump(config);
  // 	}
  // }

  /**
   * 调用拨号功能
   * @function callphone
   * @param {string} phonenum 手机号码
   * @returns {Promise<any>}
   */
  callphone = async (phonenum: string): Promise<void> => {
    const appId = await this.getAppId()
    if (appId === 'yjb3.0') {
      call(phonenum)
    } else {
      window.location.href = `http://tel:${phonenum}`
    }
  }

  /**
   * 检查登录状态
   * @function beginLogin
   * @param {string} loginType 登录类型
   * @param {string} channelId 渠道号 普通信用可缺省
   * @returns {Promise<any>}
   */
  checkLogin = async (loginType: string, channelId: string): Promise<any> => {
    if ((await this.getAppId()) === 'yjb3.0') {
      if (loginType === 'u') {
        const systemParamsterResult: any = await readSystemParameter({ keys: ['appVersion'] })
        let appVersion = null
        if (+systemParamsterResult.code === 0) {
          appVersion = systemParamsterResult.result.appVersion
        }
        const versionStrs: string = appVersion.split('.')
        if (
          parseInt(versionStrs[0], 10) >= 5 &&
          parseInt(versionStrs[1], 10) >= 1 &&
          parseInt(versionStrs[2], 10) >= 1
        ) {
          //app版本高于5.1.1
        } else {
          return { code: -2, result: 'version not supported' }
        }
        const userKey = await getUserUKeysByChannelId(channelId)
        if (userKey) {
          return { code: 0, result: userKey }
        } else {
          return { code: -1 }
        }
      } else if (loginType === 'p') {
        const uKey = await getUkeyByChannelId(channelId)
        if (uKey) {
          return { code: 0, result: uKey }
        } else {
          return { code: -1 }
        }
      } else if (+loginType === 1) {
        const loginStatus: any = await getLoginStatus()
        if (loginStatus === 1 || loginStatus === 3) {
          return { code: 0 }
        } else {
          return { code: -1 }
        }
      } else if (+loginType === 2) {
        //信用账号登录
        const loginStatus: any = await getLoginStatus()
        if (loginStatus === 2 || loginStatus === 3) {
          return { code: 0 }
        } else {
          return { code: -1 }
        }
      }
    } else {
      //todo 其他终端还不支持此功能
      return { code: -2, result: 'app not supported' }
    }
  }

  /**
   * 检查登录状态并在未登录情况下调用登录功能
   * @function beginLogin
   * @param {number} loginType 登录类型
   * @param {string} channelId 渠道号 普通信用可缺省
   * @returns {Promise<any>}
   */
  beginLogin = async (loginType: string, channelId: string, json?: Object): Promise<any> => {
    if ((await this.getAppId()) === 'yjb3.0') {
      const checkResult = await this.checkLogin(loginType, channelId)
      if (checkResult.code == 0) {
        return checkResult
      } else if (checkResult.code == -2) {
        return { code: -2, result: 'version not supported' }
      } else {
        if (loginType === 'u') {
          const userLoginResult: any = await userLogin(json)
          if (userLoginResult.code === 0) {
            let md: MobileDetect = new MobileDetect((<any>window).navigator.userAgent)
            const os: string = md.os()
            if ('iOS' === os) {
              //适配ios移动端
              closePage({})
            }
            return await this.checkLogin(loginType, channelId)
            // if(checkLoginResult.code === 0){
            // 	return checkLoginResult;
            // }else{
            // 	//解决安卓user登录延迟问题
            // 	// await window.setTimeout(async ()=>{
            // 	// 	return this.checkLogin(loginType, channelId);
            // 	// },500);
            // 	return await this.beginLogin(loginType, channelId);
            // }
          } else {
            //取消登录,需要关闭登录页
            closePage({})
            return { code: -3 }
          }
        } else if (loginType === 'p' || +loginType === 1 || +loginType === 2) {
          const loginResult: any = await login({
            type: +loginType === 2 ? 2 : 1,
            needPassportId: 1,
            needStockAccount: 1
          })
          if (loginResult.code === 0) {
            //普通登录ios 安卓都需要执行关闭页面操作
            closePage({})
            return await this.checkLogin(loginType, channelId)
          } else {
            //取消登录，关闭登录页
            closePage({})
            return { code: -3 }
          }
        }
      }
    } else {
      //todo 其他终端还不支持此功能
      return { code: -2, result: 'app not supported' }
    }
  }

  /**
   * 打开新页面并生成token
   * @function pageInitWithToken
   * @param {number} loginType 登录类型
   * @param {string} URL 跳转URL
   * @param {boolean} needCloseCurrentView 是否需要关闭当前页
   * @param {object} config  页面跳转参数
   * @returns {Promise<void>}
   */
  pageInitWithToken = async (
    loginType: number,
    URL: string,
    needCloseCurrentView: boolean,
    config?: object
  ): Promise<void> => {
    let oConfig: any = config || {}
    if (URL.indexOf('://') === -1) {
      //非全路径
      URL = this.getPagePath() + URL
    }
    if ((await this.getAppId()) === 'yjb3.0') {
      if (window.document.title) {
        oConfig.title = window.document.title
      }
      //传递至目标页所带参数(backUrl)
      const param = encodeURIComponent(JSON.stringify(oConfig))
      // jssdk.showAlert(URL);
      // jssdk.showAlert(location.href);
      // jssdk.showAlert(`${URL === location.href}`);
      openPage(
        {
          url: `/bridge/build/openWithToken.html?login_type=${loginType}&param=${param}&back_url=${encodeURIComponent(
            URL
          )}`,
          animated: URL === location.href ? 0 : 1
        },
        needCloseCurrentView
      )
    } else {
      //暂不支持
    }
  }

  /**
   * 打开新页面并写入集群SESSION
   * @function pageInitWithSession
   * @param {number} loginType 登录类型
   * @param {string} URL 跳转URL
   * @param {boolean} needCloseCurrentView 是否需要关闭当前页
   * @param {object} config  页面跳转参数
   * @returns {Promise<void>}
   */
  pageInitWithSession = async (
    loginType: number,
    URL: string,
    needCloseCurrentView: boolean,
    config?: object
  ): Promise<void> => {
    let oConfig: any = config || {}
    if (URL.indexOf('://') === -1) {
      //非全路径
      URL = this.getPagePath() + URL
    }
    if ((await this.getAppId()) === 'yjb3.0') {
      if (window.document.title) {
        oConfig.title = window.document.title
      }
      //传递至目标页所带参数(backUrl)
      const param = encodeURIComponent(JSON.stringify(oConfig))
      openPage(
        {
          url: `/bridge/build/openWithSession.html?login_type=${loginType}&param=${param}&back_url=${encodeURIComponent(
            URL
          )}`,
          animated: URL === location.href ? 0 : 1
        },
        needCloseCurrentView
      )
    } else {
      //暂不支持
    }
  }

  /**
   * 跳转至APP下载并传参
   * @function openApp
   * @param {string} selector  APP下载事件選擇器
   * @param {OpenAppParam} config  APP下载跳转参数
   * @param {OpenAppUrlParam} urlConfig  APP下载相关URL参数
   * @returns {Promise<void>}
   */
  openApp = async (selector: string, config?: OpenAppParam, urlConfig?: OpenAppUrlParam) => {
    // let oConfig: OpenAppParam | {} = config || {};
    let action: string = ''
    let shareMarkInfo: string = ''
    let schemeUrl: string = ''

    //判断手机系统
    let md = new MobileDetect(window.navigator.userAgent)
    const os = md.os()

    //url参数设置
    let evolution_universal_url = EVOLUTION_UNIVERSAL_URL
    let evolution_txapp_url = EVOLUTION_TXAPP_URL
    let evolution_andownload_url = EVOLUTION_ANDOWNLOAD_URL
    let evolution_miniapp_url = EVOLUTION_MINIAPP_URL
    let evolution_scene_url = ''

    //识别是否时微信小程序webview嵌入,此方法不稳定，且只支持到微信7.0, 如有需要兼容微信7.0以下需要传入urlConfig
    let isMini = !!window.navigator.userAgent.match(/miniProgram/i)
    let appId = isMini ? 'miniApp' : await this.getAppId()

    const setConfigParams = async (config?: OpenAppParam, urlConfig?: OpenAppUrlParam) => {
      if (urlConfig) {
        isMini = urlConfig.EVOLUTION_PAGE_ENV ? urlConfig.EVOLUTION_PAGE_ENV === 'miniApp' : isMini
        appId =
          urlConfig.EVOLUTION_PAGE_ENV && urlConfig.EVOLUTION_PAGE_ENV === 'insertApp'
            ? 'insertApp'
            : appId
        evolution_miniapp_url = urlConfig.EVOLUTION_MINIAPP_URL || EVOLUTION_MINIAPP_URL
        evolution_scene_url = ''

        if (urlConfig.EVOLUTION_SCENE_INFO && urlConfig.EVOLUTION_SCENE_INFO.URL) {
          evolution_scene_url =
            urlConfig.EVOLUTION_SCENE_INFO.SHORT_LINK === 1
              ? await getShortLink(urlConfig?.EVOLUTION_SCENE_INFO?.URL)
              : urlConfig.EVOLUTION_SCENE_INFO.URL
        }
        evolution_universal_url = urlConfig.EVOLUTION_UNIVERSAL_URL || EVOLUTION_UNIVERSAL_URL
        evolution_txapp_url = urlConfig.EVOLUTION_TXAPP_URL || EVOLUTION_TXAPP_URL
        evolution_andownload_url = urlConfig.EVOLUTION_ANDOWNLOAD_URL || EVOLUTION_ANDOWNLOAD_URL
      }

      let oConfig: any = config || {}
      /**
       * 处理可能存在的url中包含多余分享字段
       */
      if (oConfig && oConfig.param && oConfig.param.url) {
        const url = new URI(oConfig.param.url)
        url.setQuery({
          app_id: 'yjb3.0'
        })
        url.removeQuery('shareMarkInfo')
        oConfig.param.url = url.href()
      }
      action = encodeURIComponent(JSON.stringify(oConfig))
      try {
        let searchParams = new URLSearchParams(location.search)
        shareMarkInfo = encodeURIComponent(searchParams.get('shareMarkInfo') || '')
      } catch (e) {}

      schemeUrl = `com.yjb.jy://?action=${action}`
      if ('iOS' === os) {
        //TOTO 地址后面需要灵活配置
        schemeUrl = `${evolution_universal_url}${
          evolution_universal_url.includes('?') ? '&' : '?'
        }action=${action}&shareMarkInfo=${shareMarkInfo}`
        // schemeUrl = `com.yjb.jy://?action=${action}`;
      } else if ('AndroidOS' === os) {
        schemeUrl = `yjbapp://?action=${action}&shareMarkInfo=${shareMarkInfo}`
      } else {
        //jssdk.showAlert('不支持下载');
      }
    }
    await setConfigParams(config, urlConfig)

    //获取 shareLinkId ,用于分享回流统计
    // let shareLinkId, chaseId, userKey;
    // try {
    // 	let searchParams = new URLSearchParams(location.search);
    // 	shareLinkId = searchParams.get('shareLinkId') || '';
    // 	chaseId = searchParams.get('chaseId') || '';
    // 	userKey = searchParams.get('userKey') || '';
    // } catch (e) { }
    // const shareMarkInfo = encodeURIComponent(JSON.stringify({ shareLinkId: shareLinkId, chaseId: chaseId, userKey: userKey }));

    //将地址复制到剪切板

    // Object.prototype.toString.call(selector)=="[object String]"
    if (!(<any>window).clipboard) (<any>window).clipboard = {}
    if ((<any>window).clipboard[selector]) (<any>window).clipboard[selector].destroy()
    ;(<any>window).clipboard[selector] = new Clipboard(selector, {
      text: function(ele) {
        //只有安卓需要剪切板， ios 有两个进程分别执行url参数和剪切板，同时存在会重复处理
        let data = ele.getAttribute('data-open-config') || ''
        let dataUrl = ele.getAttribute('data-open-urlConfig') || ''
        if (data) {
          try {
            config = JSON.parse(data)
            if (dataUrl) urlConfig = JSON.parse(dataUrl)
            setConfigParams(config, urlConfig)
          } catch (e) {}
        }
        return 'iOS' === os ? 'yjbapp://' : schemeUrl
      }
    })
    ;(<any>window).clipboard[selector].on('success', function(e: any) {
      console.log(e)
      openAppFunction()
    })
    ;(<any>window).clipboard[selector].on('error', function(e: any) {
      console.log(e)
      openAppFunction()
    })
    const openAppFunction = () => {
      // iframe环境直接拦截
      if (isIframeClient()) {
        console.log('isIframeClient')
        iframePostMessage({ funcCode: 'e001', data: { config, urlConfig } })
        return false
      }
      console.log('openAppFunction')
      // 小程序环境里不执行回流，跳转到小程序引流页。
      if (appId === 'miniApp') {
        const url = new URI(evolution_miniapp_url)
        url.setQuery({
          action: action,
          shareMarkInfo: shareMarkInfo
        })
        window.location.href = decodeURIComponent(url.href())
      } else if (appId === 'yjbwx') {
        if ('AndroidOS' === os) {
          //复制后直接跳到腾讯应用宝处理
          // pageInit(`https://linkm.yjbtest.com/download/app-download.html?&action=${action}`, false, {});
          let url =
            evolution_scene_url ||
            `${evolution_txapp_url}&android_schema=${encodeURIComponent(schemeUrl)}`
          pageInit(`${url}`, false, {})
          // pageInit(`${evolution_txapp_url}&android_schema=${encodeURIComponent(`yjbapp://?action=${JSON.stringify(oConfig)}`)}`, false, {});
        } else if ('iOS' === os) {
          //直接跳转到Universal,这里不需要copy,如果安装app 会带上,未安装则会跳转至下载页面,在下载页面执行copy操作
          // Copy(schemeUrl);
          let url = `${evolution_universal_url}${
            evolution_universal_url.includes('?') ? '&' : '?'
          }action=${action}&shareMarkInfo=${shareMarkInfo}`
          pageInit(
            evolution_scene_url
              ? `${url}&sceneUrl=${encodeURIComponent(evolution_scene_url)}`
              : `${url}`,
            false,
            {}
          )
        }
      } else {
        if ('AndroidOS' === os) {
          //原设置为4000
          let t = 1000,
            hasApp = true
          //设置定时器,判断如果没有呼起app,则调用定时器,跳转下载(至腾讯应用宝 or apk下载)
          setTimeout(function() {
            if (!hasApp) {
              let url =
                evolution_scene_url ||
                (appId === 'insertApp'
                  ? `${evolution_txapp_url}&android_schema=${encodeURIComponent(schemeUrl)}`
                  : evolution_andownload_url)
              pageInit(`${url}`, false, {})
            }
          }, 1500)

          let t1 = Date.now()
          window.location.href = schemeUrl
          setTimeout(() => {
            let t2 = Date.now()
            if (t2 - t1 < t + 100) {
              hasApp = false
            }
          }, t)
        } else if ('iOS' === os) {
          let url = `${evolution_universal_url}${
            evolution_universal_url.includes('?') ? '&' : '?'
          }action=${action}&shareMarkInfo=${shareMarkInfo}`
          pageInit(
            evolution_scene_url
              ? `${url}&sceneUrl=${encodeURIComponent(evolution_scene_url)}`
              : `${url}`,
            false,
            {}
          )
        }
      }
    }
  }
  wechatAuth = (<any>wechatAccount).wechatAuth // 佣金宝公众号授权
  getWechatUserInfo = (<any>wechatAccount).getWechatUserInfo // 获取佣金宝公众号用户信息
  h5Pay = (<any>webPay).h5Pay // H5支付
}

// module.exports = evolution;
const evolution = new Evolution()

export default evolution

/**
 * 获取AppId
 * @function getAppId
 * @returns {Promise<string>}
 */
export const getAppId = evolution.getAppId
/**
 * 获取页面路径
 * @function getPagePath
 * @returns {string}
 */
export const getPagePath = evolution.getPagePath
/**
 * 打开新页面
 * @function pageInit
 * @param {string} URL 页面URL
 * @param {boolean} needCloseCurrentView 是否需要关闭当前页面 缺省false
 * @param {object} config 打开页面参数
 * @returns {Promise<void>}
 */
export const pageInit = evolution.pageInit
/**
 * 页面返回
 * @function goBackPage
 * @param {any} config 设置参数
 * @returns {Promise<void>}
 */
export const goBackPage = evolution.goBackPage
/**
 * 设置标题栏
 * @function setTitle
 * @param {any} config 设置参数(类open参数)
 * @returns {Promise<any>}
 */
export const setTitles = evolution.setTitles
/**
 * 调用拨号功能
 * @function callphone
 * @param {string} phonenum 手机号码
 * @returns {Promise<any>}
 */
export const callphone = evolution.callphone
/**
 * 检查登录状态
 * @function beginLogin
 * @param {number} loginType 登录类型
 * @param {string} channelId 渠道号 普通信用可缺省
 * @returns {Promise<any>}
 */
export const checkLogin = evolution.checkLogin
/**
 * 检查登录状态并在未登录情况下调用登录功能
 * @function beginLogin
 * @param {number} loginType 登录类型
 * @param {string} channelId 渠道号 普通信用可缺省
 * @returns {Promise<any>}
 */
export const beginLogin = evolution.beginLogin
/**
 * 打开新页面并生成token
 * @function pageInitWithToken
 * @param {number} loginType 登录类型
 * @param {string} URL 跳转URL
 * @param {boolean} needCloseCurrentView 是否需要关闭当前页
 * @param {object} config  页面跳转参数
 * @returns {Promise<void>}
 */
export const pageInitWithToken = evolution.pageInitWithToken

/**
 * 打开新页面并生成SESSION
 * @function pageInitWithSession
 * @param {number} loginType 登录类型
 * @param {string} URL 跳转URL
 * @param {boolean} needCloseCurrentView 是否需要关闭当前页
 * @param {object} config  页面跳转参数
 * @returns {Promise<void>}
 */
export const pageInitWithSession = evolution.pageInitWithSession

/**
 * 跳转至APP下载并传参
 * @function openApp
 * @param {string | Element | NodeListOf<Element>}  selector  APP下载事件選擇器
 * @param {OpenAppParam} config  APP下载跳转参数
 * @param {OpenAppUrlParam} urlConfig  APP下载相关URL参数
 * @returns {Promise<void>}
 */
export const openApp = evolution.openApp

export const wechatAuth = evolution.wechatAuth

export const h5Pay = evolution.h5Pay

export const getWechatUserInfo = evolution.getWechatUserInfo
